import Vue from 'vue';
import Router from 'vue-router';
import { setTitle } from '@/utils';
import { env, Native } from '@hb/NBridge/lib/h5';
// -- 卡券商城路由处理 start --
import { appQueryConfig } from '@/pages/mall/common/utils/url';
// -- 卡券商城路由处理 end --
import routes from './routes';

Vue.use(Router);

const router = new Router({
  routes,
});
let lastMeta = null;
function handleNavStatusBar(meta = {}) {
  if (env.isEasyBikeApp) {
    const { hideNavBar, statusBarColor } = meta || {};
    Native.callNative({
      classMap: 'NavBar',
      method: 'setStatusBarColor',
      params: { isShowStatusBar: !hideNavBar, colorCode: statusBarColor || 'white' },
    }).catch(() => { });
    Native.toggleNavBar({ isShow: !hideNavBar }).catch(() => { });
  }
}

// -- 卡券商城路由处理 start --
function handleCouponMallRoute(to, from, next) {
  const resolvedQuery = {
    ...appQueryConfig, // 先放入默认配置
    ...to.query, // 再放入新的参数，确保新参数能覆盖默认配置
  };

  // 卡券商城首页包括 /mall 和 /bounty
  const isMallHomePage = to.path === '/mall' || to.path === '/bounty';

  // 如果 meta 中包含 hideNavBar 属性，设置导航栏和状态栏
  if (to.meta && typeof to.meta.hideNavBar !== 'undefined' && isMallHomePage) {
    handleNavStatusBar(to.meta);
  }

  if (!isMallHomePage || to.query.isFirst === '1') {
    next();
  } else {
    next({
      ...to,
      query: {
        ...resolvedQuery,
        isFirst: '1',
      },
      replace: true,
    });
  }
}
// -- 卡券商城路由处理 end --

router.beforeEach((to, from, next) => {
  // -- 卡券商城路由 start --
  if (to.meta.source === 'couponMall') {
    lastMeta = to.meta || {}; // 为了不破坏福利中心原有逻辑，这里不优化了
    handleCouponMallRoute(to, from, next);
    return;
  }
  // -- 卡券商城路由 end --

  const { title } = to.meta || {};
  lastMeta = to.meta || {};
  if (title) setTitle(title);
  handleNavStatusBar(to.meta || {});

  next();
});


function pageShowHandler() {
  if (env && env.isEasyBikeApp) {
    window.addEventListener('pageshow', () => {
      handleNavStatusBar(lastMeta);
    });
  }
}
pageShowHandler();
window.$router = router;

export default router;
